import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import RecoilNexus from "recoil-nexus";
import 'antd/dist/antd.css';
import 'index.css';
import { App } from 'App';
import ErrorBoundary from '_components/ErrorBoundary';

ReactDOM.render(
    <React.StrictMode>
        <RecoilRoot>
            <RecoilNexus />
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </RecoilRoot>
    </React.StrictMode>,
    document.getElementById('app')
);

// Register the service worker (production only) to enable installability /
// "Add to Home Screen". In dev it stays off to avoid stale-asset caching.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').catch((err) => {
            // Non-fatal: the app works fine without the SW, just not installable.
            console.error('Service worker registration failed:', err);
        });
    });
}
